module.exports = "//static.hsappstatic.net/salesImages/static-1.403/integrations/sfdc_install/install-visualforce-4.png"